// services/exploreDataService.js

const BASE_URL = process.env.REACT_APP_BASE_URL;
  const token = window.sessionStorage.getItem("jwtToken");

console.log(BASE_URL)

/**
 * Fetch all explore data.
 */
export const fetchAllExploreData = async () => {
  try {
    const response = await fetch(`${BASE_URL}/getAllExploreDataBySection`,
      {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Origin': 'http://68.183.95.58:8081',
      'Access-Control-Allow-Credentials': 'true',
       Authorization: `Bearer ${token}`
    },

  });
  
    
    if (!response.ok) {
      throw new Error('Failed to fetch all explore data');
    }
    const data = await response.json();
    console.log(data);
  return data; 
  } catch (error) {
    console.error('Error fetching all explore data:', error);
    throw error;
  }
};

/**
 * Fetch explore data by type.
 */
export const fetchExploreDataBySection = async (section) => {
  try {
    const response = await fetch(`${BASE_URL}/getExploreData/${section}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Origin': 'http://68.183.95.58:8081',
      'Access-Control-Allow-Credentials': 'true',
       Authorization: `Bearer ${token}`
    },
  });
    if (!response.ok) {
      throw new Error('Failed to fetch data for type');
    }
    const data = await response.json();
    return data.data.exploreData || [];
  } catch (error) {
    console.error('Error fetching explore data by type:', error);
    throw error;
  }

};


export const updateExploreData = async (updatedData) => {
  try {
    const response = await fetch(`${BASE_URL}/updateExploreData`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
         Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(updatedData),
    });

    if (!response.ok) {
      throw new Error('Failed to update explore data');
    }

    return await response.json();
  } catch (error) {
    console.error('Error updating explore data:', error);
    throw error;
  }
};

